import { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import EditModalPreferenceScores from "./EditModalPreferenceScores";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function PreferenceScores() {
  const snapshot = useSelector(state => state.snapshot.fileName);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const [editModal, setEditModal] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      const data = await api.getGlobalSettings(snapshot);
      setSettings(data);
      setLoading(false);
    } catch (error) {
      toastService.send({ title: "Fout", message: `${error}` });
    }
  };

  const openEditModal = () => {
    setEditModal(
      <EditModalPreferenceScores
        hideModal={() => {
          setEditModal(null);
          load();
        }}
        data={settings}
      />,
    );
  };

  useEffect(() => { load(); }, [snapshot]);

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }

  return (
    <Container>
      {editModal}
      <Row>
        <h1>Drempelwaarden voorkeuren</h1>
      </Row>
      <Row className="my-2">
        <Col>
          <p className="text-muted">
            Docenten geven een voorkeur van 1 tot 10 per vak. Deze drempelwaarden bepalen de kleurweergave in de hoewist-resultaten.
          </p>
        </Col>
        <Col className="text-end">
          <Button variant="success" onClick={openEditModal} disabled={snapshot}>
            <i className="far fa-pencil" />
            &nbsp;Bewerk
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <ul>
            <li>
              <span className="text-success fw-bold">Hoge voorkeur</span> (groen vanaf): <strong>{settings.preferenceScoreHigh ?? 7}</strong>
            </li>
            <li>
              <span className="text-warning fw-bold">Neutrale voorkeur</span> (oranje vanaf): <strong>{settings.preferenceScoreLow ?? 4}</strong>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default PreferenceScores;
